import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import DispatchScheduleCard from "../../Components/Card/DispatchScheduleCards/DispatchScheduleCard";
import DispatchScheduleTable from "../../Components/Card/DispatchScheduleCards/DispatchScheduleTable";

const DispatchSchedule = () => {
  const { is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const [isCreate, setIsCreate] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const handlePopup = () => {
    setIsCreate(!isCreate);
  };

  return (
    <Container>
      <CardHeadMenu
        prefix="Na"
        suffix="Na"
        title="Dispatch Schedule"
        handlePopup={handlePopup}
        create={isCreate}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(79))}
      />

      <DispatchScheduleCard
        isCreate={isCreate}
        setIsCreate={setIsCreate}
        isChanged={isChanged}
        setIsChanged={setIsChanged}
      />

      <DispatchScheduleTable isChanged={isChanged} />
    </Container>
  );
};

export default DispatchSchedule;
